import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Input,
  Label,
  Form,
  FormGroup,
  Col,
  Row,
  FormFeedback
} from 'reactstrap';

import {
  PageWrapper,
  PanelWrapper,
  PanelTopWrapper,
  TitlePage,
  InputFile,
  SaveOrCancel,
  Loader,
  AlertMessage
} from 'components';

import {
  InputValidation,
  PostBrandService,
  MessageRequest,
  GetUniqueBrandService,
  UpdateBrandService,
  validateMultiplesFormData
} from 'services';

import './brands.scss';
import * as yup from 'yup';
var formData = new FormData();
export const BrandsDetail = () => {

  let { topicId } = useParams();

  const populateObject = (invalid, message) => {
    return ({
      invalid,
      message
    })
  }

  const [message, setMessage] = useState("");
  const [active, setActive] = useState(false);
  const [name, setBrandName] = useState(populateObject(false, ""));
  const [defaultPhrase, setDefaultPhrase] = useState(populateObject(false, ""));
  const [sendPhrase, setSendPhrase] = useState(populateObject(false, ""));
  const [linkBanner, setLinkBanner] = useState(populateObject(false, ""));
  const [url, setUrl] = useState(populateObject(false, ""));
  const [code, setCode] = useState(populateObject(false, ""));
  const [avatar, setAvatar] = useState(populateObject(false, ""));
  const [logo, setLogo] = useState(populateObject(false, ""));
  const [banner, setBanner] = useState(populateObject(false, ""));

  const brandSchema = yup.object().shape({
    sendPhrase: yup.string().required(),
    code: yup.string().required(),
    defaultPhrase: yup.string().required(),
    name: yup.string().required(),
    url: yup.string().matches('.*(?<!/)$').required(),
    avatar: yup.string().required(),
    logo: yup.string().required()
  });

  const brandFormData = {
    name: name.value,
    defaultPhrase: defaultPhrase.value,
    sendPhrase: sendPhrase.value,
    linkBanner: linkBanner.value,
    url: url.value,
    code: code.value,
    avatar: avatar.value,
    logo: logo.value
  }

  useEffect(() => {
    if (topicId !== "new") {
      GetUniqueBrandService(topicId).then((value) => {
        setBrandName({ value: value?.name })
        setSendPhrase({ value: value?.phraseSend })
        setDefaultPhrase({ value: value?.phraseBrand })
        setLinkBanner({ value: value?.linkBanner })
        setUrl({ value: value?.url })
        setCode({ value: value?.code })
        setAvatar({ value: value.imageAvatar })
        setLogo({ value: value.imageLogo })
        setBanner({ value: value.imageBanner })
      });
    }

  }, [topicId]);

  const getPopulateObject = (input, value) => {

    const inputs = {
      name: () => {
        setBrandName(populateObject(true, value))
      },
      defaultPhrase: () => {
        setDefaultPhrase(populateObject(true, value))
      },
      sendPhrase: () => {
        setSendPhrase(populateObject(true, value))
      },
      linkBanner: () => {
        setLinkBanner(populateObject(true, value))
      },
      url: () => {
        setUrl(populateObject(true, value))
      },
      code: () => {
        setCode(populateObject(true, value))
      },
      avatar: () => {
        setAvatar(populateObject(true, value))
      },
      logo: () => {
        setLogo(populateObject(true, value))
      }
    }
    return inputs[input] ? inputs[input]() : sendInformations();
  }

  const getValidation = async () => {

    const feedback = await Promise.resolve(
      InputValidation(
        {
          schema: brandSchema,
          formdata: brandFormData
        })
    ).then(value => value);

    if (feedback?.id) {
      return feedback.id.forEach((element, index) => {
        getPopulateObject(element, feedback.error[index]);
      });
    }

    return getPopulateObject(feedback?.id);

  }

  const validateOptionalInput = (code, value) => {
    if (value) formData.append(code, value);
  }

  const sendInformations = () => {
    formData.append("name", name.value);
    formData.append("defaultPhrase", defaultPhrase.value);
    formData.append("sendPhrase", sendPhrase.value);
    formData.append("url", url.value);
    formData.append("code", code.value);
    validateOptionalInput("linkBanner", linkBanner.value);

    formData = validateMultiplesFormData(formData, ["name", "defaultPhrase", "sendPhrase", "linkBanner", "code", "url", "fileAvatar", "fileLogo", "fileBanner"]);

    if (topicId === "new") {
      PostBrandService(formData).then(function (response) {
        MessageRequest("Marca cadastrada", response, setMessage, setActive);
      })
    } else {
      UpdateBrandService(formData, topicId).then(function (response) {
        MessageRequest("Marca editada", response, setMessage, setActive);
      })

    }

  }

  const toggle = (value) => {
    setActive(value);
  }

  const getInputFile = (image, value) => {
    formData.append(value, image);
  }

  return (
    <PageWrapper>
      <PanelTopWrapper padding={"py-4"}>
        <TitlePage title={'Marcas'} />
      </PanelTopWrapper>
      <PanelWrapper>
        <Form>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label for="marca">Marca *</Label>
                <Input
                  invalid={name.invalid}
                  value={name.value}
                  id="marca"
                  onChange={(e) => setBrandName({ value: e.target.value })}
                  placeholder={'Ex: Arezzo'} />
                <FormFeedback> {name.message} </FormFeedback>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="code">Código *</Label>
                <Input
                  invalid={code.invalid}
                  value={code.value}
                  id="code"
                  onChange={(e) => setCode({ value: e.target.value })}
                  placeholder={'Ex: arezzo'} />
                <FormFeedback> {code.message} </FormFeedback>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="url">Url *</Label>
                <Input
                  invalid={url.invalid}
                  value={url.value}
                  id="url"
                  onChange={(e) => setUrl({ value: e.target.value })}
                  placeholder={'Ex: http://www.arezzo.com.br'} />
                <FormFeedback> {url.message} </FormFeedback>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label>Imagem do Avatar *</Label>
                <InputFile getBinaryImage={getInputFile} id={'fileAvatar'} invalid={avatar.invalid} getNameImage={(name) => setAvatar({ value: name })} file={avatar} />
              </FormGroup>
            </Col>
            <Col >
              <FormGroup>
                <Label>Imagem do Logo *</Label>
                <InputFile getBinaryImage={getInputFile} id={"fileLogo"} invalid={logo.invalid} getNameImage={(name) => setLogo({ value: name })} file={logo} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label for="fraseLoja">Frase padrão da Loja *</Label>
                <Input
                  invalid={defaultPhrase.invalid}
                  type="textarea"
                  value={defaultPhrase.value}
                  onChange={(e) => setDefaultPhrase({ value: e.target.value })}
                  placeholder="Ex: Escolha a sua cidade e fale no WhatsApp com a Arezzo mais próxima de você."
                  name="text"
                  id="fraseLoja" />
                <FormFeedback> {defaultPhrase.message} </FormFeedback>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label for="fraseEnvio">Frase padrão do Envio * </Label>
                <Input
                  invalid={sendPhrase.invalid}
                  type="textarea"
                  value={sendPhrase.value}
                  placeholder="Ex: Olá, tudo bem? Estou entrando em contato porque quero saber mais sobre"
                  onChange={(e) => setSendPhrase({ value: e.target.value })}
                  name="text"
                  id="fraseEnvio"
                />
                <FormFeedback> {sendPhrase.message} </FormFeedback>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label> Imagem do Banner (1440px x 575px) </Label>
                <InputFile getBinaryImage={getInputFile} id={"fileBanner"} getNameImage={() => { }} file={banner} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label for="linkBanner">Link do Banner</Label>
                <Input
                  invalid={linkBanner.invalid}
                  value={linkBanner.value}
                  onChange={(e) => setLinkBanner({ value: e.target.value })}
                  type="url"
                  id="linkBanner"
                  placeholder="Ex: https://www.arezzo.com.br/c/sapatos"
                />
                <FormFeedback> {linkBanner.message} </FormFeedback>
              </FormGroup>
            </Col>
          </Row>
        </Form>
        <SaveOrCancel
          actionCancel={'marcas'}
          actionSave={getValidation} />
      </PanelWrapper>
      <AlertMessage message={message} active={active} toggle={toggle} />
      <Loader />
    </PageWrapper>
  );
};
